import {useI18n} from 'i18n/I18nContext'
import EventProductsProvider, {
  Product,
  useEventProducts,
} from 'organization/Event/Products/EventProductsProvider'
import React from 'react'
import Form from 'react-bootstrap/Form'

type ProductSelectorProps = {
  value: number | null
  setFieldValue: (field: string, value: string) => void
  label: string
  name: string
}

export function ProductSelector(props: ProductSelectorProps) {
  return (
    <EventProductsProvider>
      <Content {...props} />
    </EventProductsProvider>
  )
}

const Content = (props: ProductSelectorProps) => {
  const {t} = useI18n()
  const {value, setFieldValue, name} = props

  const handleOnChange = (value: string) => {
    setFieldValue(name, value)
  }

  const {products, loading} = useEventProducts()

  return (
    <Form.Group className="mb-3 pb-2">
      <Form.Label>{props.label}</Form.Label>
      <Form.Select
        onChange={(e) => {
          handleOnChange(e.target.value)
        }}
        className="form-control"
        value={value || ''}
      >
        {loading && <option value="">{t('templateEditor.loading')}</option>}
        <option value="">{t('templateEditor.selectProductForSale')}</option>
        {products.map((product: Product) => {
          return <option value={product.id}>{product.name}</option>
        })}
      </Form.Select>
    </Form.Group>
  )
}
